import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosCfdiConfiguracionLista', {
    template: template,
    controller: NominasNominaDocumentosCfdiConfiguracionListaComponent,
    bindings: {
      data: '<',
      onChange: '&',
    },
  })

function NominasNominaDocumentosCfdiConfiguracionListaComponent($filter) {
  let $ctrl = this,
    filterBy = $filter('filter'),
    orderBy = $filter('orderBy')
  $ctrl.$onChanges = $onChanges
  $ctrl.filtrar = filtrar
  $ctrl.seleccionar = seleccionar
  $ctrl.totalizar = totalizar

  $ctrl.areas = []
  $ctrl.departamentos = []
  $ctrl.estados = []
  $ctrl.filtro_area = ''
  $ctrl.filtro_departamento = ''
  $ctrl.filtro_estado = ''
  $ctrl.todos = {
    enviar_email: false,
    generar_pdf: false,
    generar_xml: false,
  }
  $ctrl.acciones = {
    enviar_email: false,
    generar_pdf: false,
    generar_xml: false,
  }

  function $onChanges(changes) {
    if (changes.data && changes.data.currentValue) {
      $ctrl.data = orderBy(changes.data.currentValue, 'colaborador')

      $ctrl.acciones.enviar_email = $ctrl.data.some(function (item) {
        return item.email && item.enviar_email !== null
      })

      $ctrl.acciones.generar_pdf = $ctrl.data.some(function (item) {
        return item.generar_pdf !== null
      })

      $ctrl.acciones.generar_xml = $ctrl.data.some(function (item) {
        return item.generar_xml !== null
      })

      $ctrl.estados = $ctrl.data
        .reduce(function (array, item) {
          if (array.indexOf(item.estado) < 0)
            array.push(item.estado)

          return array
        }, [])
        .sort()

      $ctrl.departamentos = $ctrl.data
        .reduce(function (array, item) {
          if (array.indexOf(item.departamento) < 0)
            array.push(item.departamento)

          return array
        }, [])
        .sort()

      $ctrl.areas = $ctrl.data
        .filter(function (item) {
          return item.area
        })
        .reduce(function (array, item) {
          if (array.indexOf(item.area) < 0)
            array.push(item.area)

          return array
        }, [])
        .sort()

      filtrar()
    }
  }

  function filtrar() {
    let resultados = filterBy($ctrl.data, $ctrl.filtro)

    if ($ctrl.filtro_estado)
      resultados = resultados.filter(function (item) {
        return item.estado === $ctrl.filtro_estado
      })

    if ($ctrl.filtro_departamento)
      resultados = resultados.filter(function (item) {
        return item.departamento === $ctrl.filtro_departamento
      })

    if ($ctrl.filtro_area)
      resultados = resultados.filter(function (item) {
        return item.area === $ctrl.filtro_area
      })

    $ctrl.resultados = resultados

    totalizar()
  }

  function seleccionar(key) {
    $ctrl.resultados.forEach(function (item) {
      item[key] = (item[key] === null) ? null : !$ctrl.todos[key]
    })

    totalizar()
  }

  function totalizar() {
    angular.forEach($ctrl.todos, function (val, key) {
      $ctrl.todos[key] = $ctrl.resultados.every(function (item) {
        return (item[key] === null) ? true : item[key]
      })
    })

    $ctrl.onChange()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/cfdi/configuracion/lista/component.js